import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { isExperimentEnabled } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { isRemixOptedOut } from './isRemixOptedOut.ts';

/**
 * Returns whether remix features are available for the current user/site.
 *
 * Checks that:
 * 1. When cc-maui-feature-encoding-sdk-exp is enabled, the confluence-remix AEM feature is
 *    available. The experiment selects how availability is resolved; while it is disabled,
 *    existing behaviour is preserved until the AEM data includes the new feature key.
 * 2. Rovo LLM is enabled on the site (isRovoLLMEnabled)
 * 3. The tenant/org has not opted out of remix — checked before the experiment
 *    so opted-out users do not fire a cc-maui-experiment exposure
 * 4. The MAUI experiment is enabled (cc-maui-experiment)
 *
 * Use this hook to gate all remix entrypoints (buttons, nudge icons, toolbars)
 * so they are completely hidden when remix is not available.
 */
export const useIsRemixAvailable = (): boolean => {
	const { isRovoLLMEnabled } = useSessionData();

	if (isExperimentEnabled('cc-maui-feature-encoding-sdk-exp')) {
		if (!isFeatureEnabled('confluence', 'confluence-remix')) {
			return false;
		}
	}

	return isRovoLLMEnabled && !isRemixOptedOut() && isExperimentEnabled('cc-maui-experiment');
};
